module.exports = __webpack_public_path__ + "img/zubut-blue.f647db62.png";